import React from 'react'
import RecommendedKots from 'components/RecommendedKots/RecommendedKots'
import RecommendedKotsForUser from 'pages/user/PersonalDashboard/components/RecommendedKotsForUser/RecommendedKotsForUser'

import Oops from '../components/Oops/Oops'

const LostKotPage = (props) => {
    const { user } = props

    return (<>
        <Oops subtitleId="transl_kots.does_not_exist_banner" />
        {user?.school_location
            ? <RecommendedKotsForUser
                fullWidth
                key='recommended_kots_for_user'
                user={user}
                textValues={{ school: user.school_location }}
                location={user.school_location}
            />
            : <RecommendedKots user={user} />
        }
    </>)
}

export default LostKotPage
